import { Box, Typography } from '@mui/material';

type Tokens = { font: string; muted: string; border: string };

const PILL_BG = '#E3E3E8';

// Widths vary per row so the placeholder reads as a list of names, not a grid of bars.
const PILL_WIDTHS = ['62%', '78%', '54%', '70%', '66%', '82%', '58%', '74%', '60%', '68%'];

export function TableLoading({ tokens, rows = 10 }: { tokens: Tokens; rows?: number }) {
  return (
    <Box data-testid="table-loading">
      <Typography
        role="status"
        sx={{
          px: '16px',
          pb: '8px',
          fontFamily: tokens.font,
          fontSize: 13,
          lineHeight: '20px',
          color: tokens.muted,
        }}
      >
        Loading students — this can take up to a minute.
      </Typography>
      <Box aria-hidden="true">
        {Array.from({ length: rows }, (_, i) => (
          <Box
            key={i}
            data-testid="table-loading-row"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '24px',
              height: 48,
              px: '16px',
              borderBottom: `1px solid ${tokens.border}`,
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Box sx={{ height: 16, width: PILL_WIDTHS[i % PILL_WIDTHS.length], bgcolor: PILL_BG, borderRadius: 999 }} />
            </Box>
            <Box sx={{ width: 160, height: 16, bgcolor: PILL_BG, borderRadius: 999 }} />
            <Box sx={{ width: 64, height: 16, bgcolor: PILL_BG, borderRadius: 999 }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
